













































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { Tabs, DialogMain } from '@/components/index'
import { WebhookAddStepPage, WebhookTaskPage } from '@/api/Webhook'
import { WebhookTaskPageForm } from '@/types/Webhook'
@Component({
  components: {
    Tabs,
    DialogMain
  },
})
export default class Step3 extends Vue {
  @Prop() step2Form!:any
  /**
   * tabs tab切换
   * tabsArr 数组
   * tabsActive 当前项
   *
   * dialogVisible 弹框状态
   * form
   *   name 任务名称
   *   webhookId 选择webhook
   *   webhookArr webhook下拉框
   * preinstall 预定参数
   * custom 自定义参数
   */

  /**
   * 方法
   *
   * handleDel 表格 删除
   * handleEdit 表格编辑
   */

  tabObj = {
    tabsArr: [
      {
        id: 1,
        name: 'Webhook',
      },
    ],
    tabsActive: 0,
  };
  tableData:any = [];
  tableClientData:any = []
  dialogVisible: Boolean = false;
  /**
   * custom 自定义
   * preinstall 预定义
   */
  form:any = {
    name: '',
    webhookId: '',
    webhookArr: [],
    webhookParamMap: {
      custom: [],
      //  [{
      //   code: 'q',
      //   desc: 'x',
      //   type: 'custom',
      //   value: '新增的'

      // }]

      preinstall: []
      // [{
      //   code: 'UserId',
      //   desc: '对象实例ID',
      //   type: 'instanceId',
      //   value: ''
      // }, {
      //   code: 'userSex',
      //   desc: '用户性别',
      //   type: 'preinstall',
      //   value: '男'

      // }]
    }
  };
  /**
   * 预设参数
   */
  reserveParams:any = [];
  /**
   * 自定义参数
   */
  flowParams:any = [];
  created() {
    this.handleType()
    this.getAddWebhookPage()
  }
  handleType() {
    const { type } = this.$route.query
    if (type === 'add') {
      this.handleAddData()
    } else {
      this.handleEditData()
    }
  }
  handleAddData() {

  }
  /**
   * 触发switch
   * handleSwitch
   */
  handleSwitch(item:any) {
    const { tableClientData } = this
    const _status = tableClientData.find((node:any) => node.id === item.id)
    if (_status) {
      const idx = tableClientData.findIndex((node:any) => node.id === item.id)
      this.tableClientData[idx].status = item.status
    } else {
      var _item = item
      this.tableClientData.push(item)
    }
  }
  async handleEditData() {
    const groupPage = await this.getGroupPage()
    this.tableData = groupPage.records
  }
  async getGroupPage() {
    const { grouping } = this.step2Form
    const { objectId } = this.$route.query
    const params:WebhookTaskPageForm = {
      id: objectId,
      planId: grouping,
      size: 1000
    }
    const { data } = await WebhookTaskPage(params)
    // status 1 开启  2 禁用
    for (let i = 0; i < data.records.length; i++) {
      data.records[i].status = data.records[i].status === 1
    }
    return data
  }
  async getAddWebhookPage() {
    const { data } = await WebhookAddStepPage({})
    this.form.webhookArr = data.records
  }

  /**
   * webhook参数设置
   */
  @Watch('form.webhookId')
  handleWebhookParams(val: any) {
    if (val.length < 1) {
      return
    }
    const { webhookArr, webhookId } = this.form
    const paramsObj = webhookArr.find((item: any) => item.id === webhookId)
    const paramsArr = JSON.parse((paramsObj as any).params)

    const custom:any = []
    const preinstall:any = []
    paramsArr.forEach((item: any) => {
      /**
       * custom 自定义参数
       * preinstall
       * instanceId 预设参数 不可变
       */
      if (item.type === 'custom') {
        custom.push({
          ...item,
          value: '',
        })
      } else {
        preinstall.push({
          ...item,
          value: item.value || '',
        })
      }
    })
    this.form.webhookParamMap.custom = custom
    this.form.webhookParamMap.preinstall = preinstall
  }
  /**
   * createDialog 打开模态框
   *
   */
  createDialog() {
    this.dialogVisible = true
    this.form.name = ''
    this.form.clientType = ''
    this.form.webhookId = ''
    this.flowParams = []
  }
  /**
   * 确认
   * handleConfirm
   */
  handleConfirm() {
    this.dialogVisible = false
    const { form, tableData } = this
    const { name, webhookId, webhookArr, webhookParamMap } = form
    const singleData = webhookArr.find((item: any) => item.id === webhookId)
    const _date = (new Date()).getTime()
    let data: any = {}
    if (form.clientType === 'edit') {
      // form.webhookId === (singleData as any).id
      data = {
        ...form,
        ids: (singleData as any).id,
        webhookName: (singleData as any).name,
      }

      const idx = tableData.findIndex((item:any) => item.id === data.id)
      this.tableData.splice(idx, 1, data)
      this.tableClientData.splice(idx, 1, data)
    } else {
      data = {
        id: 'client' + _date,
        ids: (singleData as any).id,
        name: name,
        webhookName: (singleData as any).name,
        status: true,
        webhookParamMap
      }
      this.tableData.unshift(data)
      this.tableClientData.unshift(data)
    }
  }

  handleClose() {
    this.dialogVisible = false
  }
  /**
   * 编辑
   */
  handleEdit(row: any) {
    this.dialogVisible = true
    this.form.webhookId = (row.id.toString()).indexOf('client') === -1 ? row.webhookId : row.ids
    this.form.id = row.id
    this.form.status = row.status
    this.form.webhookParamMap = row.webhookParamMap
    this.form.clientType = 'edit'
    this.form.name = row.name
  }
  handleDel(row: any) {
    const idx = this.tableData.findIndex((item:any) => item.id === row.id)
    this.tableData.splice(idx, 1)
    const clientDel = (row.id.toString()).indexOf('client') !== -1
    if (!clientDel) {
      this.tableClientData.push({
        ...row,
        clientType: 'del'
      })
    } else {
      const clientIdx = this.tableClientData.findIndex((item:any) => item.id === row.id)
      this.tableClientData.splice(clientIdx, 1)
    }
  }

  vaildSubmit(cb: Function) {
    // (this.$refs.form as cusElForm).validate((valid: boolean) => {
    //   if (valid) {
    // eslint-disable-next-line standard/no-callback-literal
    const { tableData, tableClientData } = this
    // eslint-disable-next-line standard/no-callback-literal
    cb(true, { tableData, tableClientData })
  }
}
